import React from "react";
import "./styles/bookListPagination.css";

function BookListPagination({ pageForward, pageBack, maxPages, page, goToPage }) {
  return (
    <div className="bookListPagination-wrapper">
      <button className="btn btn-sm btn-secondary-light" onClick={pageBack} disabled={page === 0}>
        <svg
          viewBox="0 0 24 24"
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth={3.5}
          strokeLinecap="round"
        >
          <path d="m16.5 3-9 9 9 9" />
        </svg>
      </button>
      <div style={{ height: "fit-content" }}>
        Page{" "}
        {/* if there's only one page it's pointless to render the select element, so
            I just return the "1" to make the component look a little more polished */}
        {maxPages === 1 ? (
          <span className="">1</span>
        ) : (
          <label>
            <select
              className="select select-sm border border-gray-300"
              value={page}
              onChange={(e) => goToPage(Number(e.target.value))}
            >
              {Array.from(Array(maxPages).keys()).map((page) => (
                <option key={page} value={page}>
                  {page + 1}
                </option>
              ))}
            </select>
          </label>
        )}{" "}
        of {maxPages}
      </div>
      <button className="btn btn-sm btn-secondary-light" onClick={pageForward} disabled={page === maxPages - 1}>
        <svg
          viewBox="0 0 24 24"
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth={3.5}
          strokeLinecap="round"
        >
          <path d="m7.5 21 9-9-9-9" />
        </svg>
      </button>
    </div>
  );
}

export default BookListPagination;
